export default {
  title: 'Nowa cena',
  fields: {
    product: {
      label: 'Produkt',
    },
    is_not_personal: {
      label: 'Widoczne dla wszystkich',
    },
    is_default: {
      label: 'Domyślny',
    },
    visible_to: {
      label: 'Widoczne dla',
    },
  },
  buttons: {
    select_all: 'Zaznacz wszystkie',
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  feedback: {
    missing_info: 'Brakujące informacje',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    price_got_created: 'Cena została utworzona',
    price_got_updated: 'Cena została zaktualizowana',
  },
};
